// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"27f408a084865841","6831":"7fe4e70be0f3236c","8503":"359716043be8b12d","9683":"635fe971d2a4bc37"}[chunkId] + ".js";
};